import { useState } from 'react';
import './MultiGridInput.css';
import { Button, Input, Space, Tooltip } from 'antd';
import { READ_ONLY_INPUT_STYLE } from '@leedpulse-monorepo/components';
import {
  DeleteOutlined,
  LinkOutlined,
  PlusCircleOutlined,
  RetweetOutlined,
} from '@ant-design/icons';

interface MultiGridInputProps {
  isCreateMode: boolean;
  initialValue?: string;
  onRemove?: () => void;
  onCreate?: (_: string) => void;
  disabled: boolean;
  isReadOnly: boolean;
  placeholder?: string;
  onAction?: (value: string) => void;
  onSwap?: () => void;
  swapTooltip?: string;
  hasError?: boolean;
  errorTooltip?: string;
}

const MultiGridInput: React.FC<MultiGridInputProps> = (props) => {
  const [wipValue, setWipValue] = useState(props.initialValue || '');

  const input = (
    <Input
      disabled={props.disabled}
      readOnly={props.isReadOnly}
      status={props.hasError ? 'error' : undefined}
      style={props.isReadOnly && !props.hasError ? READ_ONLY_INPUT_STYLE : {}}
      value={wipValue}
      onChange={(e) => setWipValue(e.target.value)}
      placeholder={props.placeholder || ''}
    />
  );

  return (
    <div className="multi-grid-input">
      <Space.Compact style={{ width: '100%' }}>
        {props.hasError && props.errorTooltip ? (
          <Tooltip title={props.errorTooltip}>{input}</Tooltip>
        ) : (
          input
        )}
        {props.isCreateMode && props.onCreate && (
          <Button
            type="primary"
            onClick={() => {
              props.onCreate!(wipValue);
              setWipValue('');
            }}
            disabled={props.disabled}
          >
            <PlusCircleOutlined />
          </Button>
        )}
        {!props.isCreateMode && props.onAction && (
          <Button
            type="primary"
            onClick={() => props.onAction!(wipValue)}
            disabled={props.disabled}
            style={{ padding: '0 14px' }}
          >
            <LinkOutlined />
          </Button>
        )}
        {!props.isCreateMode && props.onSwap && (
          <Tooltip title={props.swapTooltip || ''}>
            <Button
              type="primary"
              onClick={() => props.onSwap!()}
              disabled={props.disabled}
              style={{ padding: '0 14px', backgroundColor: '#fa8c16', borderColor: '#fa8c16' }}
            >
              <RetweetOutlined />
            </Button>
          </Tooltip>
        )}
        {!props.isCreateMode && props.onRemove && (
          <Button
            type="primary"
            danger
            onClick={() => props.onRemove!()}
            disabled={props.disabled}
            style={props.onAction || props.onSwap ? { padding: '0 14px' } : {}}
          >
            <DeleteOutlined />
          </Button>
        )}
      </Space.Compact>
    </div>
  );
};

export default MultiGridInput;
